import { NATIVE_MINT } from "@solana/spl-token";
import { EMPTY_STRING } from "../../common/constants/common.constants";
import { CLUB_CREATING_FEE } from "../../common/constants/fees";
import {
  RestrictionLocationOptions,
  RestrictionOptions,
} from "../../common/enums/civic.enum";
import {
  ApplicationStatus,
  GovernanceConfigurationType,
} from "../../common/enums/clubs-wizard.enum";
import { usdcMint } from "../../solana/common/utilities";

export const formModel = {
  formId: "create-club-form",
  formFields: {
    governance: {
      name: "governance",
      label: "Governance configuration",
      //TODO@milica-monke-merge: Only for monke, for main default is Project fundraise
      initialValue: GovernanceConfigurationType.RoleBased,
    },
    clubName: {
      name: "clubName",
      label: "Club name",
      initialValue: "",
    },
    isClubNameTaken: {
      name: "isClubNameTaken",
      label: "Club name",
      initialValue: false,
    },
    clubEmail: {
      name: "clubEmail",
      label: "Club email address",
      initialValue: "",
    },
    clubDescription: {
      name: "clubDescription",
      label: "Club description",
      initialValue: "",
    },
    clubImage: {
      name: "clubImage",
      label: "Club image",
      initialValue: "",
    },
    clubTags: {
      name: "clubTags",
      label: "Club tags",
      initialValue: [],
    },
    //TODO@milica-monke-merge: Only for monke, for main default is closed
    clubApplicationStatus: {
      name: "clubApplicationStatus",
      label: "Club application status",
      initialValue: ApplicationStatus.Opened,
    },
    twitter: {
      label: "Twitter",
      name: "twitter",
      placeholder: "Twitter link here",
      initialValue: "",
    },
    discord: {
      label: "Discord",
      name: "discord",
      placeholder: "Discord link here",
      initialValue: "",
    },
    telegram: {
      label: "Telegram",
      name: "telegram",
      placeholder: "Telegram link here",
      initialValue: "",
    },
    linkedin: {
      label: "Linkedin",
      name: "linkedin",
      placeholder: "Linkedin link here",
      initialValue: "",
    },
    reddit: {
      label: "Reddit",
      name: "reddit",
      placeholder: "Reddit link here",
      initialValue: "",
    },
    instagram: {
      label: "Instagram",
      name: "instagram",
      placeholder: "Instagram link here",
      initialValue: "",
    },
    tiktok: {
      label: "Tiktok",
      name: "tiktok",
      placeholder: "Tiktok link here",
      initialValue: "",
    },
    treasuryCap: {
      name: "treasuryCap",
      label: "Cap for treasury",
      initialValue: null,
    },
    treasuryCapStart: {
      name: "treasuryCapStart",
      label: "Start date",
      initialValue: new Date(),
    },
    treasuryCapEnd: {
      name: "treasuryCapEnd",
      label: "End date",
      initialValue: new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
    },
    owner: {
      name: "owner",
      label: "Founder",
      initialValue: true,
    },
    member: {
      name: "member",
      label: "Member",
      initialValue: true,
    },
    //TODO@milica-monke-merge: Only for monke, for main default is false
    curator: {
      name: "curator",
      label: "Manager",
      initialValue: true,
    },
    investor: {
      name: "investor",
      label: "Investor",
      initialValue: false,
    },
    //TODO@milica-monke-merge: Only for monke, for main default is EMPTY_STRING
    ownerVotingPower: {
      name: "ownerVotingPower",
      label: "",
      initialValue: 10,
    },
    //TODO@milica-monke-merge: Only for monke, for main default is EMPTY_STRING
    memberVotingPower: {
      name: "memberVotingPower",
      label: "",
      initialValue: 10,
    },
    //TODO@milica-monke-merge: Only for monke, for main default is EMPTY_STRING
    curatorVotingPower: {
      name: "curatorVotingPower",
      label: "",
      initialValue: 10,
    },
    council: {
      name: "council",
      label: "Council",
      initialValue: false,
    },
    initialMembers: {
      name: "initialMembers",
      label: "Club members",
      initialValue: [],
    },
    votingQuorum: {
      name: "votingQuorum",
      label: "Approval vote percentage",
      initialValue: 51,
    },
    maxVoteTime: {
      name: "maxVoteTime",
      label: "Max voting time",
      initialValue: 30,
    },
    //TODO@milica-monke-merge: Only for monke, for main default is EMPTY_STRING
    withdrawalVotingQuorum: {
      name: "withdrawalVotingQuorum",
      label: "Approval vote percentage",
      initialValue: 0,
    },
    withdrawalMaxVoteTime: {
      name: "withdrawalMaxVoteTime",
      label: "Max voting time",
      initialValue: 30,
    },
    //TODO@milica-monke-merge: Only for monke, for main default is EMPTY_STRING
    transferVotingQuorum: {
      name: "transferVotingQuorum",
      label: "Approval vote percentage",
      initialValue: 0,
    },
    transferMaxVoteTime: {
      name: "transferMaxVoteTime",
      label: "Max voting time",
      initialValue: 30,
    },
    votingThreshold: {
      name: "votingThreshold",
      label: "Trade & Transfer configuration",
      initialValue: [],
    },
    collectionMintAddress: {
      name: "collectionMintAddress",
      label: "Collection mint address",
      initialValue: "",
    },
    //TODO@milica-monke-merge: Only for monke, for main default is NATIVE_MINT
    mint: {
      name: "mint",
      label: "Currency",
      initialValue: usdcMint,
    },
    //TODO@milica-monke-merge: Only for monke, for main default is SOL
    mintSymbol: {
      name: "mint",
      label: "Currency symbol",
      initialValue: "USDC",
    },
    //TODO@milica-monke-merge: Only for monke, for main default is 9
    mintDecimals: {
      name: "mint",
      label: "Currency decimals",
      initialValue: 6,
    },
    nftMintAddress: {
      name: "nftMintAddress",
      label: "",
      initialValue: "",
    },
    isCollectionMintValid: {
      name: "isCollectionMintValid",
      label: "",
      initialValue: true,
    },
    totalNftVotes: {
      name: "totalNftVotes",
      label: "Total votes available",
      initialValue: null,
    },
    eligibleUsers: {
      name: "eligibleUsers",
      label: "",
      initialValue: RestrictionOptions.AllUsers,
    },
    eligibleLocation: {
      name: "eligibleLocation",
      label: "",
      initialValue: RestrictionLocationOptions.AllCountries,
    },
    termsConditions: {
      name: "termsConditions",
      label: "",
      initialValue: false,
    },
    skipFundraise: {
      name: "skipFundraise",
      label: "Skip",
      initialValue: true,
    },
    totalFees: {
      name: "totalFees",
      label: "",
      initialValue: CLUB_CREATING_FEE,
    },
    collectionData: {
      name: "collectionData",
      initialValue: "",
      label: "",
    },
    clubConfigMaxVoteTime: {
      name: "clubConfigMaxVoteTime",
      label: "Max voting time",
      initialValue: 30,
    },
    clubConfigQuorum: {
      name: "clubConfigQuorum",
      label: "Approval vote percentage",
      initialValue: 51,
    },
  },
};

export default formModel;
